import { UserSettings } from '@wellesley/openapi'

export const userSettingsKeys: (keyof UserSettings)[] = [
  'user.follow',
  'user.privacy',
  'user.translation',
  'user.discoverFeed',
  'user.notifications.prefs',
  'user.notifications.policy',
]
